import { render, staticRenderFns } from "./TestGroupHeader.vue?vue&type=template&id=7c87313d&scoped=true&"
import script from "./TestGroupHeader.vue?vue&type=script&lang=ts&"
export * from "./TestGroupHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TestGroupHeader.vue?vue&type=style&index=0&id=7c87313d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c87313d",
  null
  
)

export default component.exports